export class BrowserDetectEventUtil {

    // Get mouse wheel event supported by browser
    public static getMouseWheelEventName(): string {
        if ('onwheel' in document) {
            // IE9+, FF17+, Ch31+, Safari
            return 'wheel';
        }
        else if ('onmousewheel' in document) {
            // Obsolete event
            return 'mousewheel';
        }
        else {
            // Firefox < 17
            return 'MozMousePixelScroll';
        }
    }
}